import type { VFC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { HardwareList } from './Page';
import { QueryBuilderPage } from './routes/query-builder/Page';

export const HardwareListRouter: VFC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <HardwareList />
      </Route>
      <Route path={`${path}/:id/query-builder`}>
        <QueryBuilderPage />
      </Route>
    </Switch>
  );
};
